import { render, staticRenderFns } from "./LogoLoading.vue?vue&type=template&id=23444089&scoped=true&"
import script from "./LogoLoading.vue?vue&type=script&lang=js&"
export * from "./LogoLoading.vue?vue&type=script&lang=js&"
import style0 from "./LogoLoading.vue?vue&type=style&index=0&id=23444089&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23444089",
  null
  
)

export default component.exports